/** @format */

import { HomefieldButtonModule, HomefieldProductCardModule } from '@homefield';

import { CommonModule } from '@angular/common';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';
import { MatTabsModule } from '@angular/material/tabs';
import { MyAccountContainerComponent } from './containers/myaccount-container/myaccount-container.component';
import { MyAccountRoutingModule } from './myaccount-routing.module';
import { NgModule } from '@angular/core';
import { ProgressSpinnerModule } from '@shared/components';

@NgModule({
	declarations: [MyAccountContainerComponent],
	imports: [
		CommonModule,
		HmfButtonComponent,
		HomefieldButtonModule,
		HomefieldIconLibraryModule,
		HomefieldProductCardModule,
		MatTabsModule,
		MyAccountRoutingModule,
		ProgressSpinnerModule
	]
})
export class MyAccountModule {}
